import { useEffect } from "react";

import { useScreenManager } from "../../../hooks/use-screen-manager";

/**
 * Skips the current screen and moves to the next one.
 * This is useful for screens that are not needed or should be skipped.
 * @returns null
 */
export const SkipScreen = () => {
    const { skipScreen } = useScreenManager();
    useEffect(() => {
        skipScreen();
    }, [skipScreen]);

    return null;
};
